import { render } from "./RidFattureClientiInScadenza.vue?vue&type=template&id=2c6e2f92&scoped=true"
import script from "./RidFattureClientiInScadenza.vue?vue&type=script&lang=js"
export * from "./RidFattureClientiInScadenza.vue?vue&type=script&lang=js"

import "./RidFattureClientiInScadenza.vue?vue&type=style&index=0&id=2c6e2f92&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6e2f92"]])

export default __exports__